import React from "react";

import { useStoreTags } from "@hooks";
import { Text } from "@chakra-ui/react";
import { FirebaseContext } from "@contexts";
import { Module, DB_COLLECTION_NAMES } from "@constants";

import { query, collection, getDocs, orderBy, where } from "firebase/firestore";

import { JsonForm } from "../JsonForm";
import { ButtonModal } from "../ModalWrappers";

function download(filename: string, text: string) {
  const element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," + encodeURIComponent(text),
  );
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function MakeFailureReportsModal() {
  const [error] = React.useState("");

  const { firestore } = React.useContext(FirebaseContext);
  const collectionName = DB_COLLECTION_NAMES.MODULES;
  const collectionRef = collection(firestore, collectionName);
  const badTags = useStoreTags();

  const doSubmit = React.useCallback(async () => {
    const queryResult = query(
      collectionRef,
      orderBy("tags"),
      where("tags", "!=", []),
    );
    let dbString = "";

    Promise.all([getDocs(queryResult)]).then(([allModules]) => {
      allModules.forEach((doc) => {
        const module = doc.data() as Module;
        const timeString = module.lastUpdated
          ? module.lastUpdated.toDate().toISOString()
          : "No-Date";

        let hasBadTag = false;
        (module.tags ?? []).forEach((tag) => {
          if (badTags.includes(tag)) {
            hasBadTag = true;
          }
        });

        if (hasBadTag) {
          dbString = dbString + timeString + "," + module.id + ",";

          module.tags?.forEach((tag) => {
            if (badTags.includes(tag)) {
              dbString = " " + dbString + tag;
            }
          });
          dbString = dbString + ",";

          if (module.steps) {
            dbString = dbString + module.steps[0];
          }

          dbString = dbString + "\n";
        }
      });
    });

    const queryDebugResult = query(
      collectionRef,
      orderBy("debugTags"),
      where("debugTags", "!=", []),
    );

    Promise.all([getDocs(queryDebugResult)]).then(([allModules]) => {
      allModules.forEach((doc) => {
        const module = doc.data() as Module;
        const timeString = module.lastUpdated
          ? module.lastUpdated.toDate().toISOString()
          : "No-Date";

        dbString = dbString + timeString + "," + module.id + ",";

        module.debugTags?.forEach((tag) => {
          dbString = " " + dbString + "Debug " + tag;
        });
        dbString = dbString + ",";

        if (module.steps) {
          dbString = dbString + module.steps[0];
        }

        dbString = dbString + "\n";
      });

      download("failureReport.csv", dbString);
    });
  }, []);

  return (
    <ButtonModal
      label="Download Failure Reports"
      title="Download Failure Reports"
      size="sm"
    >
      <JsonForm fields={[]} onSubmit={doSubmit} clearAfterSubmit />
      {error ? <Text>{error}</Text> : undefined}
    </ButtonModal>
  );
}
